/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
export const localStorageKey = {
    language: '_qcells_language_',
    notice: '_qcells_notice_',
    loginFailed: '_qcells_login_failed_',
};
